import { mapBirthDate } from './mapBirthDate';
import { mapGenre } from './mapGenre';
import { ApiDNIScanResponseValues } from './types/ApiDNIScanResponseValues';
import { DocumentDNIScanData } from 'modules/ia/models/DocumentDNIScanData';

export const mapIAValues = (values: ApiDNIScanResponseValues): DocumentDNIScanData => ({
  address: {
    city: values.address.city,
    country: values.address.country,
    province: values.address.province,
    street: values.address.street,
  },
  birthAddress: {
    firstField: values.birthAddress.firstField,
    secondField: values.birthAddress.secondField,
  },
  birthDate: mapBirthDate(values.birthDate),
  firstParent: values.firstParent,
  firstSurname: values.firstSurname,
  genre: mapGenre(values.genre),
  idCard: values.idCard
    ? values.idCard.toString().toUpperCase()
    : values.idCard,
  name: values.name,
  nationality: values.nationality,
  secondParent: values.secondParent,
  secondSurname: values.secondSurname,
});
